/**
 * 异步加载文件
 * @param {String} type
 * @param {String} src
 * @param {Object} attrs
 * @param {String} el
 * @returns {void}
 */
type AllAttrs = {
    [key: string]: string;
}
type Attrs = AllAttrs & {
    src?: string;
    href?: string;
    async?: string;
    rel?: string;
    type?: string;
    style?: string;
}
export type Params = {
    label: string;
    attrs?: Attrs;
    inBody?: boolean;
}
const asyncLoadFile = ({ label, attrs = {}, inBody = true }: Params): Promise<object> => {
    return new Promise((resolve, reject) => {
        const tag = document.createElement(label)
        Object.keys(attrs).forEach(key => {
            tag.setAttribute(key, attrs[key])
        })
        tag.onload = resolve
        tag.onerror = reject
        document.getElementsByTagName(inBody ? 'body' : 'head')[0].appendChild(tag)
    })
}

export { asyncLoadFile }